import React from 'react'

export const HourglassVector = () => (
  <svg
    className="MIRECO-hourglass"
    version="1.1"
    viewBox="0 0 6.3499998 6.3499998"
    height="24"
    width="24"
  >
    <g
      transform="translate(0,-290.65)"
    >
      <path
        d="m 1.984375,291.97292 h 2.38125 c 0,1.05833 -0.5291667,1.32291 -0.9260417,1.85208 0.396875,0.52917 0.9260417,0.79375 0.9260417,1.85208 h -2.38125 c 0,-1.05833 0.5291667,-1.32291 0.9260417,-1.85208 -0.396875,-0.52917 -0.9260417,-0.79375 -0.9260417,-1.85208 z"
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: 0.396875,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
      />
      <path
        d="M 2.5135417,295.14792 H 3.8364583 C 3.571875,294.75104 3.4395833,294.35417 3.175,294.48646 c 0,0.26458 -0.396875,0.26458 -0.6614583,0.66146 z"
        style={{
          fill: '#333333',
          fillOpacity: 1,
          stroke: 'none',
          strokeWidth: '0.264583px',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeOpacity: 1,
        }}
      />
    </g>
  </svg>
)
